export default {
  LAST_SEARCH_KEY: "LAST_SEARCH_RESULTS_KEY",
  LAST_SEARCH_ARTIST_DETAILS: "LAST_SEARCH_ARTIST_DETAILS",
  LAST_SEARCH_ARTIST_EVENTS: "LAST_SEARCH_ARTIST_EVENTS",
  notifications: [
    {
      id: 1,
      text: "Hurry up! New events have been added."
    },
    {
      id: 2,
      text: "Get 50% off on every ticket booking."
    }
  ],
  NOTIFICATIONS_SEEN: "NOTIFICATIONS_SEEN"
};
